import { useState } from 'react';
import { Controller } from 'react-hook-form';

import { Button } from 'antd';

import { Icon } from '@eduzz/ui-antd-theme';

import NoImage from '/no-image.png';

import { ImageCropper } from '../ImageCropper';
import { ImageFinder } from '../ImageFinder';
import { ErrorMessage } from './ErrorMessage';

export const ImageSelector = ({ name, size = 200 }: { name: string; size?: number }) => {
  const [cropperOpen, setCropperOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <Controller
      name={name}
      rules={{ required: true }}
      render={({ field }) => (
        <div ref={field.ref} id={name}>
          <ErrorMessage fieldName={name} />

          <div className='flex justify-center'>
            <img
              src={field.value || NoImage}
              alt='Selected'
              onClick={() => {
                setCropperOpen(true);
                setSearchOpen(false);
              }}
              className='rounded-default mt-2 mb-4 max-h-48 cursor-pointer'
            />
          </div>
          <div className='flex flex-col gap-2 lg:flex-row lg:justify-center'>
            <Button
              id='upload-image'
              variant='filled'
              color='default'
              onClick={() => {
                setCropperOpen(true);
                setSearchOpen(false);
              }}
            >
              <Icon.Upload /> Enviar Imagem
            </Button>
            <Button
              id='search-image'
              variant='filled'
              color='default'
              onClick={() => {
                setCropperOpen(false);
                setSearchOpen(true);
              }}
            >
              <Icon.Search /> Pesquisar Imagem
            </Button>
          </div>
          {cropperOpen && (
            <ImageCropper
              open={cropperOpen}
              size={size}
              onCrop={croppedImage => {
                if (croppedImage) {
                  field.onChange(croppedImage);
                }

                setCropperOpen(false);
              }}
            />
          )}
          {searchOpen && (
            <ImageFinder
              open={searchOpen}
              onCrop={selectedImage => {
                if (selectedImage) {
                  field.onChange(selectedImage);
                }

                setSearchOpen(false);
              }}
            />
          )}
        </div>
      )}
    />
  );
};
